import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=308f3ec9&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=308f3ec9&lang=scss&scoped=true"
import style1 from "./edit.vue?vue&type=style&index=1&id=308f3ec9&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308f3ec9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308f3ec9')) {
      api.createRecord('308f3ec9', component.options)
    } else {
      api.reload('308f3ec9', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=308f3ec9&scoped=true", function () {
      api.rerender('308f3ec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/pageStrategy/components/edit.vue"
export default component.exports